const API = process.env.REACT_APP_BACKEND_URL;

export function useAdminApi(token) {
  const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };

  const authCheck = async (r) => {
    if (r.status === 401) { const e = new Error("unauthorized"); e.status = 401; throw e; }
    return r.json();
  };
  const getStats    = () => fetch(`${API}/api/admin/stats`,    { headers }).then(authCheck);
  const getUsers    = () => fetch(`${API}/api/admin/users`,    { headers }).then(authCheck);
  const deleteUser  = (id) => fetch(`${API}/api/admin/users/${id}`, { method: "DELETE", headers }).then(r => r.json());
  const resendCode  = (id) => fetch(`${API}/api/admin/users/${id}/resend`, { method: "POST", headers }).then(r => r.json());
  const resendWelcomeMail = (id) => fetch(`${API}/api/admin/resend-welcome/${id}`, { method: "POST", headers })
    .then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.detail); return d; });
  const updatePlan  = (id, plan) => fetch(`${API}/api/admin/users/${id}/plan`, {
    method: "PUT", headers, body: JSON.stringify({ plan }),
  }).then(r => r.json());
  const toggleSchemaBuilder = (id, unlocked) => fetch(`${API}/api/admin/users/${id}/schema-builder-access`, {
    method: "PUT", headers, body: JSON.stringify({ unlocked }),
  }).then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.detail); return d; });
  const toggleVrijeTraining = (id, enabled) => fetch(`${API}/api/admin/users/${id}/vrije-training-access`, {
    method: "PUT", headers, body: JSON.stringify({ enabled }),
  }).then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.detail); return d; });
  const toggleRooster = (id, enabled) => fetch(`${API}/api/admin/users/${id}/rooster-toggle`, {
    method: "PUT", headers, body: JSON.stringify({ enabled }),
  }).then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.detail); return d; });
  const createUser  = (name, email, plan = "full", price = null, schemaBuilderUnlocked = false) =>
    fetch(`${API}/api/admin/users`, {
      method: "POST", headers,
      body: JSON.stringify({
        name, email, plan,
        schema_builder_unlocked: schemaBuilderUnlocked,
        ...(price !== null && price !== "" ? { price: parseFloat(price) } : {}),
      }),
    }).then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.detail); return d; });
  const addSchema   = (userId, body) => fetch(`${API}/api/admin/users/${userId}/schemas`, {
    method: "POST", headers, body: JSON.stringify(body),
  }).then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.detail); return d; });
  const removeSchema = (userId, product) =>
    fetch(`${API}/api/admin/users/${userId}/schemas/${encodeURIComponent(product)}`, {
      method: "DELETE", headers,
    }).then(r => r.json());
  const getSchemaOverride  = (key) => fetch(`${API}/api/schemas/${key}`).then(r => r.json());
  const saveSchemaOverride = (key, sessions, week2_sessions) => fetch(`${API}/api/schemas/${key}`, {
    method: "PUT", headers, body: JSON.stringify({ sessions, week2_sessions }),
  }).then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.detail); return d; });
  const resetSchemaOverride = (key) =>
    fetch(`${API}/api/schemas/${key}/override`, { method: "DELETE", headers }).then(r => r.json());
  const getWorkoutStats = () => fetch(`${API}/api/admin/workout-stats`, { headers }).then(r => r.json());

  return {
    getStats, getUsers, createUser, deleteUser, resendCode, resendWelcomeMail,
    addSchema, removeSchema, getSchemaOverride, saveSchemaOverride, resetSchemaOverride,
    updatePlan, toggleSchemaBuilder, toggleVrijeTraining, toggleRooster, getWorkoutStats,
  };
}
